import { render, staticRenderFns } from "./RedirectAnmeldung.vue?vue&type=template&id=bdacedce"
import script from "./RedirectAnmeldung.vue?vue&type=script&lang=js"
export * from "./RedirectAnmeldung.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports